import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import SectionHeading from 'components/SectionHeading';
import SectionSubtitle from 'components/SectionSubtitle';
import titleUnderline from './4242.png';
import styles from './RepairRevolution.module.css';
import cardImage1 from './Startseite_Partnerschaften_Multicolumn_Leder_Desktop_Mobile_700x467px_2025-09-01 1.jpg';
import cardImage2 from './Startseite_Partnerschaften_Multicolumn_Nordwolle_Desktop_Mobile_700x467px_2025-09-01 1.jpg';
import cardImage3 from './Startseite_Partnerschaften_Multicolumn_Nordwolle_Desktop_Mobile_700x467px_2025-09-01.jpg';

const VIDEO_DE = 'tZKmepZHmp8';
const VIDEO_EN = '4VRypJCPSzw';

const CARD_IMAGE_SOURCES = [cardImage1, cardImage2, cardImage3];

const CARD_KEYS = [
  'Repair Revolution card 1',
  'Repair Revolution card 2',
  'Repair Revolution card 3',
] as const;

export default function RepairRevolution() {
  const { t } = useTranslation();
  const [videoId, setVideoId] = useState(VIDEO_DE);

  useEffect(() => {
    if (i18next.language === 'de') {
      setVideoId(VIDEO_DE);
    } else if (i18next.language === 'en') {
      setVideoId(VIDEO_EN);
    }
  }, [i18next.language]);

  return (
    <section className={styles.section} aria-labelledby="repair-revolution-heading">
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.titleWrap}>
            <SectionHeading id="repair-revolution-heading" size="large" className={styles.title}>
              {t('Repair Revolution title prefix')}
              <span className={styles.titleHighlightWrap}>
                {t('Repair Revolution title highlight')}
                <img src={titleUnderline} alt="" className={styles.titleUnderline} aria-hidden />
              </span>
            </SectionHeading>
          </div>
          <SectionSubtitle size="medium" className={styles.subtitle}>{t('Repair Revolution subtitle')}</SectionSubtitle>
        </header>

        <div className={styles.grid}>
          <div className={styles.videoCol}>
            <LiteYouTubeEmbed
              id={videoId}
              title="Repair Revolution"
              params="rel=0"
              poster="maxresdefault"
            />
          </div>
          <div className={styles.cardsCol}>
            {CARD_KEYS.map((key, index) => (
              <div key={key} className={styles.card}>
                <img
                  src={CARD_IMAGE_SOURCES[index]}
                  alt=""
                  className={styles.cardImage}
                  loading="lazy"
                />
                <h3 className={styles.cardTitle}>{t(key)}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
